import { useEffect, useState } from 'react';
import { siteMeta } from '@/mocks/gossip';

const navLinks = [
  { href: '#gusu', label: '今日速递' },
  { href: '#bang', label: '全网热榜' },
  { href: '#tuji', label: '瓜田图鉴' },
  { href: '#shen', label: '深度瓜' },
  { href: '#about', label: '关于早报' },
  { href: '#faq', label: '常见问答' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50 transition-all duration-300">
      <div
        className={`border-b transition-all duration-300 ${
          scrolled ? 'border-background-200/80 bg-background-50/90 backdrop-blur-md' : 'border-transparent bg-transparent'
        }`}
      >
        <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6" aria-label="主导航">
          <a href="#home" className="flex items-center gap-2 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
              <i className="ri-fire-fill" />
            </span>
            <span className="font-heading text-lg font-black tracking-wide text-foreground-950">吃瓜今日</span>
          </a>

          <ul className="hidden items-center gap-1 lg:flex">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="flex items-center gap-2">
            <span className="hidden items-center gap-1.5 text-xs text-foreground-500 md:inline-flex">
              <i className="ri-sun-line h-3.5 w-3.5 text-accent-600" />
              {siteMeta.edition} · {siteMeta.updateTime}
            </span>
            <a
              href="#subscribe"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              订阅早报
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 bg-background-50/80 text-foreground-900 lg:hidden"
            >
              <i className={`${open ? 'ri-close-line' : 'ri-menu-3-line'} text-xl`} />
            </button>
          </div>
        </nav>

        {open && (
          <div className="border-t border-background-200 bg-background-50 lg:hidden">
            <ul className="space-y-1 px-4 py-4">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={() => setOpen(false)}
                    className="block rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-secondary-100"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#subscribe"
                  onClick={() => setOpen(false)}
                  className="mt-2 flex items-center justify-center rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
                >
                  立即订阅每日早报
                </a>
              </li>
            </ul>
          </div>
        )}
      </div>
    </header>
  );
}